<div class="col-12 p-0 align-self-start">
  <div class="container-fluid head_wrap">
    <div class="d-flex align-items-center justify-content-between">
      <div class="l-side">
        <div class="icon toggle_wraper d-flex align-items-center">
          <div class="logo">
            <img (click)="navClick()" src="assets/images/logo.png" class="img-fluid">
          </div>
        </div>
      </div>
      <div class="r-side">
        <!-- <div class="d-flex flex-column justify-content-center mini_icons r-section">
          <mat-form-field class="titleCardSelect" *ngIf="!commentsList && kycStatus==0">
            <mat-select placeholder="Select Business Type" [(ngModel)]="messagebizId" (selectionChange)="setBiz($event)">
              <mat-option  *ngFor ="let item of messageBusinessList" [value]="item.bp_business_id"
              class="info-details" matTooltipClass="matToolTip" matTooltip="  {{item.biz_display_name}} - {{item.bp_business.account_id}}"> {{item.biz_display_name}} - {{item.bp_business.account_id}} </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="noti" *ngIf="kycStatus==2">
            User Membership Pending
            <div class="close" (click)="pendingNotification()"></div>
          </div>
        </div> -->
        
        <div class="d-flex ico_wrap justify-content-end">
          <!-- <div class="d-flex flex-column pointer justify-content-center mini_icons">
            <img src="assets/images/chat.png" [routerLink]='["/current_business/auth-message"]'>
          </div>   -->
          <!-- <div class="d-flex flex-column justify-content-center mini_icons ">
            <mat-icon class="notif_icons" matTooltip="You need to take action in the Task Management."
                [matBadge]="_api.taskCount.total? ( _api.taskCount.total > 0 ? _api.taskCount.total:''):''"
                matBadgeSize='medium' matBadgeColor="warn" (click)="backToCurrentBuisness()"><img src="assets/images/to-do-list.png" alt="" srcset="" style="vertical-align: baseline;"></mat-icon>
        </div> -->

          <div class="d-flex flex-column justify-content-center mini_icons" *ngIf="messageBusinessList.length" >
            <mat-icon class="notif_icons chat-icon"  [matBadge]="_api.messageCount.count? ( _api.messageCount.count > 0 ? _api.messageCount.count:''):''" [routerLink]='["/current_business/auth-message"]' matBadgeSize='medium' matBadgeColor="warn"></mat-icon>
          </div>
              <div class="d-flex flex-column justify-content-center mini_icons " >
                <mat-icon class="notif_icons" [ngClass]='{"shake_anim" : notifCount && router.url !== "/profile/view-notifications" }'  [matBadge]="notifCount? ( notifCount > 0 ? notifCount:''):''" [routerLink]='["/profile/view-notifications"]' matBadgeSize='medium' matBadgeColor="warn">notifications_none</mat-icon>
              </div> 
          <div class="settings d-flex flex-column justify-content-center mini_icons">
            <img src="assets/images/gear.png" [matMenuTriggerFor]="settings" class='rotate_infinite_anim'>
          </div>
          <div class="d-flex " >
            <div>
              <div class="dpCnr" [ngStyle]="{'background-image':'url(' + imgsrc +')' }"></div>
            </div>
            <div class="profileDesc">
              <div class="d-flex flex-column justify-content-center h-100">
                <p><span class="UserProfName">{{userName}}</span></p>
                <p><span class="UserAcNo" *ngIf = "accountNo"> ({{accountNo}}) </span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<mat-menu #settings="matMenu">
      <div class="col-12 bgGray matMenuHeader gearmenu">
        <ul>
          <li>
            <span class="iconContent" [routerLink]='["/current_business/profile"]'>My profile</span>
          </li>
          <!-- <li *ngIf="!is_idme_verified">
            <span class="iconContent" [routerLink]='["/identity-verification"]'>Verification</span>
        </li> -->
          <li [routerLink]='["/current_business/Security_Settings"]'>
            <span class="iconContent">Security</span>
          </li>
        </ul>
        <ul>
          <li>
            <span class="iconContent cursor-none">Help & Support</span>
          </li>
          <li>
            <span class="iconContent cursor-none">FAQ</span>
          </li>
          <li>
            <span (click)='contactUs()' class="iconContent">Contact us</span>
          </li>
      
        </ul>
        <ul>
          <li (click)="logOut()">
            <span class="iconContent">Sign out</span>
          </li>
        </ul>
      </div>

</mat-menu>